import React, { Component } from 'react'

import '../../css/loaders.css'

export default class Loader extends Component {
	render() {
		
		let style = {}
		
		if(this.props.height){
			style.height = this.props.height + 'px'
		}

		if(this.props.width){
			style.width = this.props.width + 'px'
		}

		return (
			<div class="loader"></div>
			// <div className="loader-align" style={style}>
			// 	<div className="ajax-loader">
			// 		<div className="blob top"></div>
			// 		<div className="blob bottom"></div>
			// 		<div className="blob left"></div>

			// 		<div className="blob move-blob"></div>
			// 	</div>
			// </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/utils/Loader.js